import { formatDistanceToNow } from "date-fns";
import { ar } from "date-fns/locale";

const TimeAgo = ({ createdAt }) => {
  return (
    <span>{formatDistanceToNow(new Date(createdAt), { addSuffix: true })}</span>
  );
};

export default TimeAgo;
